/* 
Displays a panel of specific Transcoder info
*/
import { useEffect, useState } from "react";
import { Stack, Text, Group, Select } from "@mantine/core";
import TranscoderInfo from "./TranscoderInfo";

export default function TranscoderView(props) {
  const [searchAddress, setSearch] = useState(props.selectedAddress);
  const thisTranscoders = props.transcoderInfo;
  // Refresh searchAddress if the selected transcoder changes
  useEffect(() => {
    if (searchAddress != props.selectedAddress) {
      setSearch(props.selectedAddress);
    }
  }, [props.selectedAddress]);
  //
  // Retrieve info object of selected transcoder and fill data for search box
  let thisSearchData = [];
  let thisInfo = null;
  for (var idx = 0; idx < thisTranscoders.length; idx++) {
    const transcoder = thisTranscoders[idx];
    if (transcoder.address == props.selectedAddress) {
      thisInfo = transcoder;
    }
    thisSearchData.push({
      value: transcoder.address,
      label: transcoder.address,
    });
  }
  // Extract only payments relevant to the T
  let thisPayments = [];
  if (props.paymentInfo) {
    for (const payment of props.paymentInfo) {
      if (props.selectedAddress == payment.recipient.toLowerCase()) {
        thisPayments.push(payment);
      }
    }
  }
  // Display search box only if no transcoder was ever selected
  if (props.selectedAddress != "" && thisInfo) {
    return (
      <Stack spacing={24}>
        <Group position="apart" spacing="28px" grow>
          <Text size="xl" fw={700}>
            Transcoder Info
          </Text>
          <Stack spacing={0}>
            <Select
              data={thisSearchData}
              label="Select Transcoder"
              placeholder="ETH address"
              transition="pop-top-right"
              description="Input the ETH address of the Transcoder you want to see info on"
              transitionDuration={80}
              transitionTimingFunction="ease"
              value={props.selectedAddress}
              onChange={props.selectTranscoder}
              onSearchChange={setSearch}
              searchValue={searchAddress}
              nothingFound="No Transcoders found"
              maxDropdownHeight={400}
              searchable
              radius="xs"
            />
          </Stack>
        </Group>
        <TranscoderInfo
          transcoder={thisInfo}
          paymentInfo={thisPayments}
        />
      </Stack>
    );
  } else {
    return (
      <Select
        data={thisSearchData}
        label="Select Transcoder"
        placeholder="ETH address"
        transition="pop-top-right"
        description="Input the ETH address of the Transcoder you want to see info on"
        transitionDuration={80}
        transitionTimingFunction="ease"
        value={props.selectedAddress}
        onChange={props.selectTranscoder}
        onSearchChange={setSearch}
        searchValue={searchAddress}
        nothingFound="No Transcoders found"
        maxDropdownHeight={400}
        searchable
        radius="xs"
      />
    );
  }
}
